import AgreementCreationPage from "./AgreementCreationPage";

export default AgreementCreationPage;